:host {
  display: contents;
}

.dialog-search {
  margin-bottom: 0.75rem;
}

.results-shell {
  container-type: inline-size;
  container-name: results;
}

.results-table-wrapper {
  overflow-x: auto;
  border: 1px solid var(--agwa-border);
  border-radius: var(--sl-border-radius-medium);
  min-height: 320px;
  position: relative;
}

.results-table-wrapper.is-refreshing .results-table {
  opacity: 0.45;
  transition: opacity 120ms ease-out;
  pointer-events: none;
}

.results-refresh-veil {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--sl-font-size-small);
  table-layout: auto;
}

.results-table th {
  text-align: left;
  padding: 0.5rem 0.85rem;
  background: var(--agwa-surface-sunken);
  border-bottom: 1px solid var(--agwa-border);
  font-weight: var(--sl-font-weight-semibold);
  color: var(--agwa-text-muted);
  white-space: nowrap;
}

.results-table th.align-center {
  text-align: center;
}
.results-table th.align-right {
  text-align: right;
}

.results-table td {
  padding: 0.55rem 0.85rem;
  border-bottom: 1px solid var(--agwa-border);
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 22rem;
}

.results-table td.align-center {
  text-align: center;
}
.results-table td.align-right {
  text-align: right;
}
.results-table td.renderer-monospace {
  font-family: var(--sl-font-mono);
  max-width: none;
}
.results-table td.renderer-status {
  max-width: none;
}

.results-table tr.data-row {
  cursor: pointer;
  transition: background 80ms;
}

.results-table tr.data-row:hover {
  background: var(--agwa-accent-soft);
}
.results-table tr.data-row.is-highlighted {
  background: var(--agwa-accent-soft);
  outline: 2px solid var(--agwa-accent);
  outline-offset: -2px;
}
.results-table tr.data-row:last-child td {
  border-bottom: none;
}

@container results (max-width: 1000px) {
  .results-table th.priority-tertiary,
  .results-table td.priority-tertiary {
    display: none;
  }
}

@container results (max-width: 720px) {
  .results-table th.priority-secondary,
  .results-table td.priority-secondary {
    display: none;
  }
}

.empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: var(--agwa-text-muted);
  font-size: var(--sl-font-size-small);
}

.load-more-row {
  margin-top: 0.75rem;
  text-align: center;
}

.loading-row {
  padding: 1.5rem;
  text-align: center;
}

sl-dialog::part(panel) {
  width: min(96vw, 1280px);
  max-width: none;
}

sl-dialog::part(body) {
  padding-block: 1rem;
}
